import $ from 'jquery';

$(".product-detail__image-trigger").on("click", function () {
	show360View( $( this ) );
});

$( ".product-detail__image-degree img" ).on( "click", function () {
	show360View( $( this ) );
} );

$(window).on('changed.zf.mediaquery', function () {
	calculateShowMore();
});

function show360View(currentAttr) {
	$( ".product-detail__image-trigger" ).hide();
	const location = currentAttr.attr( "data-location" );
	const element  = $( ".product-viewer-" + location );
	element.show();

	renderOrbitView( location, element );
}

function calculateShowMore() {
	if ($('.orbitvu-container')[0]) {
		let location = Foundation.MediaQuery.upTo('medium') ? 'mobile' : 'desktop',
			element = $(".product-viewer-" + location);

		renderOrbitView(location, element);
	}
}

function renderOrbitView(location, element) {
	let article_number = JSON.parse(element.data('article-number'));
	var force_html5 = document.location.search.indexOf('force_html5=yes') == -1 ? 'no' : 'yes';
	let height = 'auto';

	if ( screen.width >= 1025 ) {
		height = '600'
	}

	inject_orbitvu('viewer-product-id-' + location,  // id of the viewer container element which is defined above
		psh_vars.directory_uri + '/assets/flash/orbitvuer12.swf',  // location of viewer swf file
		psh_vars.directory_uri + '/assets/flash/expressInstall.swf',  // location of flash installer file
		{
			ovus_folder: psh_vars.rest_route.psh_odata_service_url + 'Catalog/odata/Images/' + article_number + '/originals/',  // location of presentation files (can be absolute or relative url)
			config_url: psh_vars.rest_route.psh_viewer_360_config + '/' + article_number + '/config',
			xml_url: psh_vars.rest_route.psh_viewer_360_config + '/' + article_number + '/content2',
			content2: 'yes',
			width: "auto",
			height: height,
			loader: 'no',
			transition: 'alpha',
			teaser: 'onerotationslow',
			force_html5: force_html5
		});


}